import { SalaryTimeSpan } from 'wisestep-api';
import { WsSelectObj } from 'wisestep-base';

const currencies = [
  'USD',
  'GBP',
  'EUR',
  'SEK',
  'CAD',
  'NOK',
  'CHF',
  'RUB',
  'INR',
  'CZK',
  'PLN',
  'AED',
  'SAR',
  'OMR',
  'QAR',
  'KWD',
  'BHD',
  'BGN',
  'SGD',
  'DKK',
  'RON',
  'NPR',
  'AUD',
  'NZD',
  'HKD',
  'MYR',
  'JPY',
  'PHP',
];

export interface ISalaryTimeSpan {
  label: string;
  value: string;
}

export const salaryTimeSpans: ISalaryTimeSpan[] = [
  { value: 'PerAnnum', label: 'Per Annum' },
  { value: 'PerMonth', label: 'Per Month' },
  { value: 'PerDay', label: 'Per Day' },
  { value: 'PerHour', label: 'Per Hour' },
];

export const getCurrencies = (): string[] => {
  return currencies;
};

export const getSalaryTimeSpans = (): ISalaryTimeSpan[] => {
  return salaryTimeSpans;
};

export const CurrencyTypeDropDownOptions: WsSelectObj[] = [
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'EUR', value: 'EUR' },
  { label: 'SEK', value: 'SEK' },
  { label: 'CAD', value: 'CAD' },
  { label: 'NOK', value: 'NOK' },
  { label: 'CHF', value: 'CHF' },
  { label: 'RUB', value: 'RUB' },
  { label: 'INR', value: 'INR' },
  { label: 'CZK', value: 'CZK' },
  { label: 'PLN', value: 'PLN' },
  { label: 'AED', value: 'AED' },
  { label: 'SAR', value: 'SAR' },
  { label: 'OMR', value: 'OMR' },
  { label: 'QAR', value: 'QAR' },
  { label: 'KWD', value: 'KWD' },
  { label: 'BHD', value: 'BHD' },
  { label: 'BGN', value: 'BGN' },
  { label: 'SGD', value: 'SGD' },
  { label: 'DKK', value: 'DKK' },
  { label: 'RON', value: 'RON' },
  { label: 'NPR', value: 'NPR' },
  { label: 'AUD', value: 'AUD' },
  { label: 'NZD', value: 'NZD' },
  { label: 'HKD', value: 'HKD' },
  { label: 'MYR', value: 'MYR' },
  { label: 'JPY', value: 'JPY' },
  { label: 'PHP', value: 'PHP' },
];

export const getDefaultTimeSpan = (selectedField) =>
  selectedField && selectedField in SalaryTimeSpan ? selectedField : SalaryTimeSpan.PerAnnum;

export const getCurrencySymbol = (acronym: string) =>
  currency_symbols[acronym] !== undefined ? currency_symbols[acronym] : acronym;

export const currency_symbols = {
  USD: '$', // US Dollar
  EUR: '€', // Euro
  CRC: '₡', // Costa Rican Colón
  GBP: '£', // British Pound Sterling
  ILS: '₪', // Israeli New Sheqel
  INR: '₹', // Indian Rupee
  JPY: '¥', // Japanese Yen
  KRW: '₩', // South Korean Won
  NGN: '₦', // Nigerian Naira
  PHP: '₱', // Philippine Peso
  PLN: 'zł', // Polish Zloty
  PYG: '₲', // Paraguayan Guarani
  THB: '฿', // Thai Baht
  UAH: '₴', // Ukrainian Hryvnia
  VND: '₫', // Vietnamese Dong
};
